import './App.css'
import { BrowserRouter, Route, Routes } from "react-router-dom";
import Home from "./pages/Home";
// import ArrearsReport from "./pages/ArrearsReport";
import Login from "./pages/Login";
import RenterDetail from './pages/RenterDetail';
import Scanner from './pages/Scanner';
// import Chat from './pages/Chat';
import CheckAuth from './Auths/CheckUser';

// import PaymentCollectionReport from './pages/PaymentCollection';
import ActiveTable from './components/PaymentCollections/Sewa/ActiveTable';

import AirActiveTable from './components/PaymentCollections/Air/ActiveTable';

import RentArreasReport from './pages/ArreasReport';
import AreaActive from './components/arreasCollection/Sewa/ActiveTable'
import AirAreaActive from './components/arreasCollection/Air/ActiveTable'

import StaffProfile from './pages/StaffProfile';
import List from './pages/List';
import QrPage from './NewPages/QrPage';
import AirClientEdit from './components/Qr/updateAirClient';
import SewaClientEdit from './components/Qr/UpdateSewaCustomer';
import Summary from './pages/Summary';
import UpdateContractForm from './components/ContractSummary/UpdateSewaContract';
import UpdateAirContractForm from './components/ContractSummary/UpdatAirContract';
import AirClientReportModal from '../src/components/Qr/AirClientReportModal';
import PromiseToPay from "./pages/PromiseToPay";

import RemarksPage from "./pages/RemarksPage";
import PaymentCollectionReport from "./pages/PaymentCollectionReport";

import TunggakanPage from "./pages/TunggakanPage";

function App() {

  const token = localStorage.getItem('token')

  if (!token) {
    return (

      <BrowserRouter>
        <Routes>
          <Route path="/" element={<Login />} />
        </Routes>
      </BrowserRouter>
    )

  } else {
    return (

      <BrowserRouter>
        <CheckAuth>
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path='/scanner' element={<QrPage />} />
            <Route path='/air-client-update/:id' element={<AirClientEdit />} />
            <Route path='/sewa-client-update/:id' element={<SewaClientEdit />} />

             <Route path='/client-report/:id' element={<AirClientReportModal />} />

            <Route path='/payment-report' element={<PaymentCollectionReport />} />
            {/* Sewa */}
            <Route path='/payment-actives' element={<ActiveTable />} />
            {/* Air */}
            <Route path='/payment-air-actives' element={<AirActiveTable />} />


            <Route path='/arrears-report' element={<RentArreasReport />} />
            {/* sewa Arrears */}
            <Route path='/arrears-actives' element={<AreaActive />} />
            {/* Air Arrears */}
            <Route path='/arrears-air-actives' element={<AirAreaActive />} />



            <Route path='/staff-detail' element={< StaffProfile />} />
            <Route path='/summary' element={< Summary />} />
            <Route path='/update-contract/:id' element={< UpdateContractForm />} />
            <Route path='/update-air-contract/:id' element={< UpdateAirContractForm />} />

            <Route path="/login" element={<Login />} />
            <Route path="/renter-detail" element={<RenterDetail />} />
            <Route path='/qrscanner' element={<Scanner />} />
            <Route path='/list' element={<List />} />

            {/* <Route path="/chat" element={<Chat />} /> */}
            <Route path='/profile' element={<StaffProfile />} />

            <Route path='/remarks/:bil' element={<RemarksPage />} />
            <Route path="/promise-to-pay" element={<PromiseToPay />} />

            <Route path="/tunggakan" element={<TunggakanPage />} />
            {/* Pending pages only design not working at all */}

          
          </Routes>
        </CheckAuth>
      </BrowserRouter>


    );
  }
}

export default App;
